var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconPlanProfessional(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 76,
    viewBox: "0 0 54 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 17.9482L23.1429 31.4095V75.9999L0 62.5542V17.9482Z",
    fill: "#51A5BF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1426 31.4095L53.9997 13.4612V58.0516L23.1426 76V31.4095Z",
    fill: "#6EC5E1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 17.9483L30.8571 0L54 13.4613L23.1429 31.4096L0 17.9483Z",
    fill: "#8BD1E8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.85645 17.9484L30.8564 2.24365L50.1422 13.4614L23.1422 29.1662L3.85645 17.9484Z",
    fill: "#599BB0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.92969 50.4797L4.82255 52.1624V56.6495L1.92969 54.9668V50.4797Z",
    fill: "#0E5C75"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2.34277 50.7236L4.82237 52.1621V56.0883L2.34277 54.6861V50.7236Z",
    fill: "#33819A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1.92969 37.0183L4.82255 38.701V43.1881L1.92969 41.5054V37.0183Z",
    fill: "#0E5C75"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M2.34277 37.2622L4.82237 38.7006V42.6268L2.34277 41.2246V37.2622Z",
    fill: "#33819A"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M2.47852 24.1184L5.37137 25.8011V30.2881L2.47852 28.6055V24.1184Z",
    fill: "#0E5C75"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M2.8916 24.3628L5.37119 25.8012V29.7274L2.8916 28.3252V24.3628Z",
    fill: "#33819A"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M6.61133 53.2839L9.50419 54.9666V59.4537L6.61133 57.771V53.2839Z",
    fill: "#0E5C75"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M7.02441 53.5283L9.504 54.9668V58.893L7.02441 57.4907V53.5283Z",
    fill: "#33819A"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M6.61133 39.823L9.50419 41.5057V45.9927L6.61133 44.3101V39.823Z",
    fill: "#0E5C75"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M7.02441 40.0674L9.504 41.5058V45.432L7.02441 44.0298V40.0674Z",
    fill: "#33819A"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M7.16309 26.9224L10.0559 28.605V33.0921L7.16309 31.4095V26.9224Z",
    fill: "#0E5C75"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M7.57617 27.1668L10.0558 28.6052V32.5314L7.57617 31.1292V27.1668Z",
    fill: "#33819A"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5713 56.0886L14.4641 57.7713V62.2584L11.5713 60.5757V56.0886Z",
    fill: "#0E5C75"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9844 56.3325L14.464 57.771V61.6971L11.9844 60.2949V56.3325Z",
    fill: "#33819A"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5713 42.6274L14.4641 44.3101V48.7972L11.5713 47.1145V42.6274Z",
    fill: "#0E5C75"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9844 42.8713L14.464 44.3098V48.236L11.9844 46.8338V42.8713Z",
    fill: "#33819A"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1221 29.7268L15.0149 31.4095V35.8965L12.1221 34.2139V29.7268Z",
    fill: "#0E5C75"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5352 29.9712L15.0147 31.4096V35.3358L12.5352 33.9336V29.9712Z",
    fill: "#33819A"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5312 58.8931L19.4241 60.5757V65.0628L16.5312 63.3802V58.8931Z",
    fill: "#0E5C75"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9443 59.1375L19.4239 60.5759V64.5021L16.9443 63.0999V59.1375Z",
    fill: "#33819A"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5312 45.4319L19.4241 47.1145V51.6016L16.5312 49.919V45.4319Z",
    fill: "#0E5C75"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9443 45.6758L19.4239 47.1142V51.0404L16.9443 49.6382V45.6758Z",
    fill: "#33819A"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M17.082 32.5315L19.9749 34.2142V38.7012L17.082 37.0186V32.5315Z",
    fill: "#0E5C75"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4951 32.7754L19.9747 34.2138V38.14L17.4951 36.7378V32.7754Z",
    fill: "#33819A"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M0 30.2881L23.1429 43.7493V44.5907L0 31.1294V30.2881Z",
    fill: "#196780"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1426 70.6716L53.9653 53.0037V53.845L23.1426 71.5129V70.6716Z",
    fill: "#4494AE"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1426 57.2101L53.9653 39.5422V40.3836L23.1426 58.0515V57.2101Z",
    fill: "#4494AE"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1426 43.7489L53.9653 26.0811V26.9224L23.1426 44.5903V43.7489Z",
    fill: "#4494AE"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M0 43.7493L23.1429 57.2105V58.0518L0 44.5906L0 43.7493Z",
    fill: "#196780"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M0 57.2104L23.1429 70.6717V71.5131L0 58.0518V57.2104Z",
    fill: "#196780"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6846 30.9887L34.4397 29.4463V33.9334L31.6846 35.4758V30.9887Z",
    fill: "#0E5C75"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6846 30.9887L34.0264 29.6785V33.6529L31.6846 34.9149V30.9887Z",
    fill: "#3D7E95"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6846 44.1699L34.4397 42.6274V47.1145L31.6846 48.657V44.1699Z",
    fill: "#0E5C75"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6846 44.1698L34.0264 42.8596V46.834L31.6846 48.096V44.1698Z",
    fill: "#3D7E95"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6846 57.6311L34.4397 56.0886V60.5757L31.6846 62.1181V57.6311Z",
    fill: "#0E5C75"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6846 57.631L34.0264 56.3208V60.2952L31.6846 61.5572V57.631Z",
    fill: "#3D7E95"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M25.624 34.6345L28.3791 33.092V37.5791L25.624 39.1216V34.6345Z",
    fill: "#0E5C75"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6221 34.6828L27.9639 33.3726V37.347L25.6221 38.609V34.6828Z",
    fill: "#3D7E95"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M25.624 47.8156L28.3791 46.2732V50.7603L25.624 52.3027V47.8156Z",
    fill: "#0E5C75"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6221 47.8637L27.9639 46.5535V50.5279L25.6221 51.7899V47.8637Z",
    fill: "#3D7E95"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M25.624 61.2768L28.3791 59.7344V64.2215L25.624 65.7639V61.2768Z",
    fill: "#0E5C75"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6221 61.3251L27.9639 60.0149V63.9893L25.6221 65.2513V61.3251Z",
    fill: "#3D7E95"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7451 27.6235L40.5002 26.0811V30.5681L37.7451 32.1106V27.6235Z",
    fill: "#0E5C75"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7451 27.6234L40.0869 26.3132V30.2876L37.7451 31.5496V27.6234Z",
    fill: "#3D7E95"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7451 40.8046L40.5002 39.2622V43.7493L37.7451 45.2917V40.8046Z",
    fill: "#0E5C75"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7451 40.8046L40.0869 39.4944V43.4688L37.7451 44.7308V40.8046Z",
    fill: "#3D7E95"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7451 54.2653L40.5002 52.7229V57.21L37.7451 58.7524V54.2653Z",
    fill: "#0E5C75"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7451 54.2653L40.0869 52.9551V56.9295L37.7451 58.1915V54.2653Z",
    fill: "#3D7E95"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2549 24.2585L46.01 22.7161V27.2032L43.2549 28.7456V24.2585Z",
    fill: "#0E5C75"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2549 24.2584L45.5967 22.9482V26.9226L43.2549 28.1846V24.2584Z",
    fill: "#3D7E95"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2549 37.4389L46.01 35.8965V40.3836L43.2549 41.926V37.4389Z",
    fill: "#0E5C75"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2549 37.4389L45.5967 36.1287V40.1031L43.2549 41.3651V37.4389Z",
    fill: "#3D7E95"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2549 50.9006L46.01 49.3582V53.8452L43.2549 55.3877V50.9006Z",
    fill: "#0E5C75"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2549 50.9005L45.5967 49.5903V53.5647L43.2549 54.8267V50.9005Z",
    fill: "#3D7E95"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5918 20.6127L52.3469 19.0703V23.5574L49.5918 25.0998V20.6127Z",
    fill: "#0E5C75"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5918 20.6127L51.9336 19.3025V23.2769L49.5918 24.5389V20.6127Z",
    fill: "#3D7E95"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5918 33.7932L52.3469 32.2507V36.7378L49.5918 38.2803V33.7932Z",
    fill: "#0E5C75"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5918 33.7931L51.9336 32.4829V36.4573L49.5918 37.7193V33.7931Z",
    fill: "#3D7E95"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5918 47.2543L52.3469 45.7119V50.199L49.5918 51.7414V47.2543Z",
    fill: "#0E5C75"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5918 47.2543L51.9336 45.9441V49.9185L49.5918 51.1805V47.2543Z",
    fill: "#3D7E95"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlanProfessional);
export default __webpack_public_path__ + "static/media/icon-plan-professional.47df9a58.svg";
export { ForwardRef as ReactComponent };